import { createAction, props } from '@ngrx/store';

export const setAccount = createAction('Account', props<{ accountId: string }>());
